
var AbstractWS = require('./AbstractWS');
var xmlToJson = require('../helpers/xmlToJson');

/**
 * @description Web Service dedicated to get the Merchant's custom fields for searching/filtering Spots
 * @method CustomFieldsWS
 * @param { ViewModel } viewModel the application's main ViewModel is the parent object of the Web Service
 * @returns { CustomFieldsWS } returns itself as API
 */
function CustomFieldsWS(viewModel) {
    var self = this;

    // Predicate this Web Service handler on the Abstract class of a Web
    // Service handler. This establishes core functionality required of
    // these such handlers, which can be overwritten by methods below.
    AbstractWS.apply(this, arguments);

    self.name = 'CustomFieldsWS';

    self.customFields = ko.observableArray([])

    // We only update the custom search fields if there is at least one Queue selected
    self.parent.selectedQueueIds.subscribe(function(queueIds) {
        if (queueIds.length > 0) {
            self.serviceURL = ko.observable('/qless/api/v1/employee/queues/' + queueIds.join(',') + '/customFields');
            self.doRequest();
        }
    });

    /**
	 * @description it overrides the superclass method
	 * @method doRequest
	 * @param {Function} callback
	 * @returns void
	 */
    self.doRequest = function (callback) {
        AbstractWS.prototype.doRequest.call(self, callback);
    };


    /**
     * @description of the processData() method
     * @method processData the function executed as callback from the AJAX request
     * @param { XMLString } xmlData the xml data returned from the service
     * @returns { CustomFieldsWS } returns the object itself as chainable, for best practice
     */
    self.processData = function(xmlData) {
        // Call the superclass method to perform any core actions
        AbstractWS.prototype.processData.call(self, xmlData);

        var json = xmlToJson.parse(xmlData);
        var customFields = [];
        if (json && json.customFields.customField) {
            customFields = json.customFields.customField;
        }
        self.customFields(customFields)

    };

    return self;
}

CustomFieldsWS.prototype = AbstractWS.prototype;
CustomFieldsWS.prototype.constructor = CustomFieldsWS;

module.exports = CustomFieldsWS;
